// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"13a5aa7d","239":"e065d644","553":"54250e0c"}[chunkId] + ".chunk.js";
};